import { Component, effect, inject, input, model } from '@angular/core';
import { AdvertisingService } from '../services/advertising.service';
import { RoutesService } from '../../shared/services/routes.service';
import { AdvertisingEnum } from '../../shared/enum/advertising.enum';
import { TypeEnum } from '../../core/enums/type.enum';
import { AccessModel } from '../../core/models/access.model';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { RippleModule } from 'primeng/ripple';
import { MultiSelectChangeEvent, MultiSelectModule } from 'primeng/multiselect';
import { ImageModel } from '../../shared/models/image.model';
import { FormService } from '../../shared/services/form.service';
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { Api } from '../../core/constants/api.constants';
import { ContractModel } from '../../shared/models/contract.model';
import {
  DropdownChangeEvent,
  DropdownModule,
} from 'primeng/dropdown';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { ImagesCrateComponent } from '../../images/images-crate/images-crate.component';
import { ChipModule } from 'primeng/chip';
import { HttpParams } from '@angular/common/http';
import { ProfileService } from '../../profile/services/profile.service';
import { ResourceFormCardComponent } from '../../shared/components/resource-form-card/resource-form-card.component';
import { BranchModel } from '../../shared/models/branch.model';
import { UserInterface, UsersInterface } from '../../user/interfaces/user.interface';
import { User, Users } from '../../user/models/user.model';
import { Advertising } from '../models/advertising.model';
import { AdvertisingFormGroupInterface } from '../interfaces/advertising-form.interface';
import { CalendarModule } from 'primeng/calendar';
import { Image, Images } from '../../images/models/image.model';
import { ImagesInterface } from '../../images/interfaces/image.interface';

@Component({
  selector: 'app-advertising-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardModule,
    ButtonModule,
    ButtonGroupModule,
    RippleModule,
    MultiSelectModule,
    GalleriaModule,
    ImageModule,
    DropdownModule,
    ToggleButtonModule,
    InputTextModule,
    InputTextareaModule,
    DialogModule,
    ImagesCrateComponent,
    ChipModule,
    ResourceFormCardComponent,
    CalendarModule,
  ],
  templateUrl: './advertising-form.component.html',
  styleUrl: './advertising-form.component.css',
})
export class AdvertisingFormComponent {
  protected service = inject(AdvertisingService);
  protected routesService = inject(RoutesService);
  protected formService = inject(FormService);
  private profile = inject(ProfileService).profile() as User;
  private contract = this.profile.contract as ContractModel;
  private branch = this.profile.branch as BranchModel;

  constructor() {
    effect(() => {
      const value = this.value();
      if (this.formGroup) {
        this.formGroup = this.service.getFormGroup(value);
      }
    });
  }

  protected typeEnum = TypeEnum;
  protected enum = AdvertisingEnum;
  protected resource = this.service.resource;
  protected resources = this.formService.resources;

  public access = input.required<AccessModel | undefined>();
  protected imageUrlBase = Api.url.base;

  public id = input<string | undefined | null>(undefined);

  public value = model<Advertising>();
  protected images = model<Images>();
  protected display = model<Users>();
  protected contracts = model<ContractModel[]>();
  protected branches = model<BranchModel[]>();

  public edit = model<boolean>(false);
  public create = model<boolean>(false);
  public delete = model<boolean>(false);
  public details = model<boolean>(false);
  uploadvisible: boolean = false;

  protected formGroup!: FormGroup<AdvertisingFormGroupInterface>;

  protected loading = model<boolean>(false);

  protected saveButton!: boolean;
  protected editButton!: boolean;

  ngOnInit(): void {
    this.saveButton = this.saveButtonVisible();
    this.editButton = this.editButtonVisible();
    this.formGroup = this.service.getFormGroup(this.value());
    this.getContract();
    if (this.value()) {
      this.contract = this.value()?.contract ?? this.contract
      this.getBranches(this.value()?.contract);
      this.getImages(this.value()?.contract);
      this.getDisplay(this.value()?.contract, this.value()?.branches);
    }
  }

  protected submit() {
    this.loading.update((value: boolean) => {
      return false;
    });
    this.formGroup.value.images

    this.service.form(this.formGroup, this.value()).subscribe(
      (res) => {
        this.loading.update((value: boolean) => {
          return false;
        });
        this.routesService.details(this.resource, res.data?._id);
      },
      (error) => {
        this.loading.update((value: boolean) => {
          return false;
        });
      }
    );
  }

  getImages(contract?: ContractModel) {
    if (
      !this.access()?.image.actions.read ||
      (!this.edit() && !this.create()) ||
      !contract
    ) {
      return;
    }
    const params: HttpParams = new HttpParams({
      fromObject: { contract: contract._id },
    });
    return this.formService
      .getList(this.resources.image, params)
      ?.subscribe((res) => {
        this.images.update((value) => {
          return Image.fromArray(res as ImagesInterface);
        });
      });
  }
  getDisplay(contract?: ContractModel, branches?: BranchModel[]) {
    console.log('get display');
    console.log(`contract: ${contract}, branches: ${branches}`);
    if (
      !this.access()?.display.actions.read ||
      (!this.edit() && !this.create()) ||
      !contract ||
      !branches
    ) {
      return;
    }
    const params: HttpParams = new HttpParams({
      fromObject: {
        contract: contract._id,
        branches:
          branches.length > 1
            ? branches.map((value) => value._id as string)
            : [],
        branch:
          branches.length == 1
            ? branches.map((value) => value._id as string)[0]
            : [],
      },
    });
    return this.formService
      .getList(this.resources.display, params)
      ?.subscribe((res) => {
        this.display.update((value) => {
          return (res as UsersInterface).map((value) => new User(value as UserInterface));
        });
      });
  }
  getContract() {
    if (!this.edit() && !this.create()) {
      return;
    }
    if (!this.access()?.contract.actions.read) {
      return this.getBranches(this.contract);
    }
    return this.formService
      .getList(this.resources.contract)
      ?.subscribe((res) => {
        this.contracts.update((value) => {
          return res as ContractModel[];
        });
      });
  }
  getBranches(contract?: ContractModel) {
    if ((!this.edit() && !this.create()) || !contract) {
      return;
    }
    if (!this.access()?.branch.actions.read) {
      return this.getData(contract, [this.branch]);
    }
    const params: HttpParams = new HttpParams({
      fromObject: { contract: contract._id, details: false },
    });
    return this.formService
      .getList(this.resources.branch, params)
      ?.subscribe((res) => {
        this.branches.update((value) => {
          return res as BranchModel[];
        });
      });
  }

  upload() {
    this.uploadvisible = true;
  }

  contractSelect(event?: DropdownChangeEvent) {
    console.log('event: ', event);
    if (event && event.value) {
      const contract = event.value as ContractModel;
      this.contract = contract;
      console.log('contract: ', this.contract);
      this.getBranches(contract);
    }
  }
  branchesSelect(event?: MultiSelectChangeEvent) {
    console.log('event: ', event);
    if (event && event.value) {
      const branches = event.value;
      console.log('branches: ', branches);
      this.getData(this.contract, branches);
    }
  }

  getData(contract: ContractModel, branches: BranchModel[]) {
    // console.log('contract: ', contract);
    this.getImages(contract);
    this.getDisplay(contract, branches);
    // this.getBranches(contract)
  }

  private saveButtonVisible(): boolean {
    return this.edit() || this.create();
  }

  private editButtonVisible(): boolean {
    const create: boolean = !this.edit() && !this.create() && !this.delete();
    const edit: boolean = this.access()?.advertising?.actions?.update
      ? true
      : false;
    return create && edit;
  }
}
